import {isCustomProperty} from 'cl-api';
import * as React from 'react';
import update from 'immutability-helper';
import connectWithRouter from '../../../shared/components/redux/connectWithRouter';
import {ACTION_DISPLAY_TYPES} from '../../../shared/ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../shared/ActionsManager/ActionsTypes';
import ClearSelectionButton from 'cl-table/ClearSelectionButton';
import FormTable, {FormTableProps} from 'cl-form/FormTable';
import GeneralActions from '../../../shared/ActionsManager/GeneralActions/GeneralActions';
import * as _ from 'lodash';
import {getVariationAspectNames, getVariationsTableRows} from '../EditProductSelectors';
import {FormContext} from 'cl-form/FormContext/FormContextProvider';
import {PRODUCT_VARIATIONS_TABLE, VARIATION_OPTIONS_FIELDS, VISIBLE_PRODUCT_FIELDS} from '../consts';
import {ColumnsType} from 'cl-table/redux/actions';
import {nonEmpty} from 'cl-form/validation/validators';
import BulkEditButton from 'cl-table/BulkEdit/BulkEditButton';

export function sortProductVariationsColumns(columns) {
  const sortedColumnsArray = [
    ...VISIBLE_PRODUCT_FIELDS,
    ...VARIATION_OPTIONS_FIELDS,
    ..._.filter(_.keys(columns), isCustomProperty),
  ];
  const sortedColumnNames = _.keys(columns);
  sortedColumnNames.sort((columnA, columnB) => {
    return _.indexOf(sortedColumnsArray, columnA) - _.indexOf(sortedColumnsArray, columnB);
  });
  return sortedColumnNames;
}

const VariationsProductSection: React.FunctionComponent<FormTableProps & {variationAspectNames: string[]}> = ({
  data,
  variationAspectNames,
  ...otherProps
}) => {
  const {sections} = React.useContext(FormContext);

  const columns = React.useMemo(() => {
    const columns: ColumnsType = {};
    _.forEach(sections, section => {
      _.forEach(section.fieldsInfo, fieldProps => {
        const fieldName = fieldProps.name;
        if (_.indexOf(variationAspectNames, fieldName) !== -1) {
          columns[fieldName] = {...fieldProps, readOnly: true};
        } else if (_.indexOf(VISIBLE_PRODUCT_FIELDS, fieldName) !== -1) {
          columns[fieldName] = {...fieldProps, validator: fieldName === 'SKU' ? nonEmpty : undefined};
        }
      });
    });
    return columns;
  }, [sections, variationAspectNames]);

  const updateVariation = (columnName, variations, variationId, value) => {
    return {
      [variationId]: update(variations[variationId], {
        [columnName]: {
          $set: value,
        },
      }),
    };
  };

  return (
    <FormTable
      tableName={PRODUCT_VARIATIONS_TABLE}
      columns={columns}
      data={data}
      updateRow={updateVariation}
      // thumbnail
      selectable
      config={{id: '_id', columnsSorter: sortProductVariationsColumns}}
      filterProps={{preventMoreFilters: true}}
      actions={{
        left: (
          <GeneralActions
            types={[
              GENERAL_ACTIONS_TYPES.OPEN_ADD_PRODUCT_VARIATION_DIALOG,
              GENERAL_ACTIONS_TYPES.OPEN_EDIT_PRODUCT_VARIATION_OPTIONS_DIALOG,
            ]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            additionalActionData={sections}
          />
        ),
        selectedRight: (
          <React.Fragment>
            <GeneralActions
              types={[GENERAL_ACTIONS_TYPES.DELETE_PRODUCT_VARIATIONS]}
              displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            />
            <ClearSelectionButton />
          </React.Fragment>
        ),
        selectedLeft: <BulkEditButton />,
      }}
      {...otherProps}
    />
  );
};

export default connectWithRouter(
  state => ({
    data: getVariationsTableRows(state),
    variationAspectNames: getVariationAspectNames(state),
  }),
  {}
)(VariationsProductSection);
